// Core
import React from "react";

const Skill = (props) => {
    const points = [];

    for (let i = 0; i < 10; i++) {
        let inactiveClass = "inactive";

        if (props.points >= i + 1) {
            inactiveClass = "";
        }

        points.push(<li className = { inactiveClass } key = { i } />);
    }

    return (
        <div className = 'skill'>
            <span>{props.title}</span>
            <ul>{points}</ul>
        </div>
    );
};

export default Skill;
